export type TransportProcentualMultiProductMode = 'per_product' | 'percentage'

export interface TransportProcentualConfig {
  enabled: boolean
  multiProductMode: TransportProcentualMultiProductMode
  percentage: number
}

export interface TransportProcentualLine {
  productId: number
  quantity: number
  shippingPriceTur?: number | null
  shippingPriceRetur?: number | null
}

function roundMoney(value: number): number {
  return Math.round((Number(value) || 0) * 100) / 100
}

function positiveMoney(value: unknown): number {
  const n = Number(value)
  if (!Number.isFinite(n) || n <= 0) return 0
  return roundMoney(n)
}

function lineShipping(line: TransportProcentualLine): number {
  const tur = positiveMoney(line.shippingPriceTur)
  const retur = positiveMoney(line.shippingPriceRetur)
  const qty = Math.max(1, Math.floor(Number(line.quantity) || 1))
  return roundMoney((tur + retur) * qty)
}

export function calculateTransportProcentualShipping(
  lines: TransportProcentualLine[],
  config: Pick<TransportProcentualConfig, 'enabled' | 'multiProductMode' | 'percentage'>,
  eligibleSubtotal = 0,
): number {
  if (!config.enabled || !lines.length) return 0

  const uniqueProductCount = new Set(
    lines.map((line) => Number(line.productId)).filter((id) => Number.isFinite(id) && id > 0),
  ).size

  if (config.multiProductMode === 'percentage' && uniqueProductCount > 1) {
    const pct = Math.max(0, Number(config.percentage) || 0)
    return roundMoney((Math.max(0, Number(eligibleSubtotal) || 0) * pct) / 100)
  }

  return roundMoney(lines.reduce((sum, line) => sum + lineShipping(line), 0))
}
